// extracted by mini-css-extract-plugin
export default {"Spinner":"FeedbackSpinner_Spinner__YT1ps"};